export const APP_PUBLIC_PLAYER_HOST_ID = 'APP_PUBLIC_PLAYER_HOST_b192a8f0';
export const APP_PUBLIC_PLAYER_SETTINGS_HOST = 'APP_PUBLIC_PLAYER_SETTINGS_HOST_b192a8f0';
